import React from "react"
import { useContext, useState } from "react"
import {
  Accordion as AccordionBs,
  AccordionContext,
  Card,
  useAccordionToggle
} from "react-bootstrap"
import { Arrow } from "../Icons/SVG/arrow.jsx"

export const Accordion = ({ items = [], allowMultiple = false, borderHeader = false, toggleClassName = "" }) => {
  const [activeKeys, setActiveKeys] = useState(new Set())

  const AccordionToggle = ({ children, eventKey, callback }) => {
    const currentEventKey = useContext(AccordionContext)

    const onClick = useAccordionToggle(eventKey, () => {
      if (allowMultiple) {
        setActiveKeys((prev) => {
          const newSet = new Set(prev)
          if (newSet.has(eventKey)) {
            newSet.delete(eventKey)
          } else {
            newSet.add(eventKey)
          }
          return newSet
        })
      }
      callback && callback(eventKey)
    })

    const isCurrentEventKey = allowMultiple
      ? activeKeys.has(eventKey)
      : currentEventKey === eventKey

    return (
      <div
        className={`d-flex justify-content-between align-items-center px-5 py-3 cursor-pointer ${
          borderHeader && "border-1 border-bottom"
        } ${toggleClassName}`}
        onClick={onClick}>
        {children}
        <Arrow direktion={isCurrentEventKey ? "up" : "down"}></Arrow>
      </div>
    )
  }

  if (!allowMultiple) {
    return (
      <AccordionBs defaultActiveKey="0">
        {items.map((e, i) => (
          <Card className="mb-3" key={i}>
            <AccordionToggle eventKey={i.toString()}>{e?.header}</AccordionToggle>
            <AccordionBs.Collapse eventKey={i.toString()}>
              <Card.Body>{e?.content}</Card.Body>
            </AccordionBs.Collapse>
          </Card>
        ))}
      </AccordionBs>
    )
  }

  return (
    <AccordionBs>
      {items.map((e, i) => (
        <Card className="mb-3" key={i}>
          <AccordionToggle eventKey={i.toString()}>{e?.header}</AccordionToggle>
          <AccordionBs.Collapse eventKey={i.toString()} in={activeKeys.has(i.toString())}>
            <Card.Body>{e?.content}</Card.Body>
          </AccordionBs.Collapse>
        </Card>
      ))}
    </AccordionBs>
  )
}
